//注册对话框

import AXIOS from '@/utils/$axios';

//获取图形验证码
export const getImageVerificationCode = data =>
    AXIOS.get('/hdc-admin/sys/imageCaptcha.jpg?uuid=' + data, {
        responseType: 'blob',
    });

//校验图片验证码
export const verifyImageVerificationCode = data =>
    AXIOS.post('/hdc-admin/sys/verify/imageCaptcha', data);

//获取短信验证码
export const getSMSVerificationCode = data =>
    AXIOS.post('/hdc-admin/sys/sms/send', data);

//注册
export const userRegister = data => {
    return AXIOS.post('/hdc-admin/sys/user/register', data);
};

// 已注册检测
export const checkRegister = data => {
    return AXIOS.post('/hdc-admin/sys/user/check-mobile', data);
};

// 登录
export const postLogin = data => AXIOS.post('/hdc-admin/sys/hdc-login', data);

// 退出登录
export const postLogout = () => AXIOS.post('/space/common/login-out');
/*  */
// 申请企业试用
export const enterpriseUserAdd = data =>
    AXIOS.post('/hdc-admin/enterprise/user/add', data);

// 微信公众号 判断是否登录过
export const checkWcpLogin = params =>
    AXIOS.get('/hdc-admin/sys/wc-authorize', { params });

// 获取用户信息
export let getUserInfo = params =>
    AXIOS.get(`/hdc-admin/enterprise/user/info/${params.entId}`);

// 解绑用户微信
export let unboundWeichart = () => AXIOS.get('/hdc-admin/sys/user/unbound');

// 获取用户信息
export let putUserInfo = data => AXIOS.post('/hdc-admin/sys/user/update', data);

// 校验验证码
export const checkSms = data =>
    AXIOS.post('/hdc-admin/sys/user/checkSms', data);
// 重置密码
export const modifyPassword = data =>
    AXIOS.post('/hdc-admin/sys/user/modifyPassword', data);

// 生成定微信的二维码
export const creatBindQrcode = data =>
    AXIOS.post('/hdc-admin/sys/wechat-mp-qrcode/create', data);

// 设置绑定邮箱
export const sendEmail = data => AXIOS.post('/hdc-admin/sys/mail/send', data);

// 设置绑定邮箱
export const bindEmail = params =>
    AXIOS('/hdc-admin/sys/use/bind-mail', { params });
